import { NgModule } from '@angular/core';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

@NgModule({
  exports: [NgxDaterangepickerMd],
  imports: [NgxDaterangepickerMd.forRoot()],
})
export class DaterangepickerConfigModule {}
